import React from "react";

function PathTypeString({str}:{str:string}) {

    if(str.includes('플러스'))
        return <div style={{fontSize:'small',color:'gray'}}>{str}</div>
    else
        return <div>{str}</div>
}

export default PathTypeString